export class FacturaReport {
    constructor(
        public renta: string = "",
        public flim: string = "",
        public estado: string = "",
        public categoria: string = "",
        public formulario: string = "",
        public costoAgua: number = 0,
        public codigoControl: string = "",
        public servicioAgua: string = "",
        public fechaVencimiento: string | null = null,
        public leyenda: string = "",
        public glosa: string = "",
        public nfac: string = "",
        public descripcionConsumo: string = "",
        public consumoMes: string = "",
        public tarifa: string = "",
        public total: number = 0,
        public lecturaActual: string = "",
        public lecturaAnterior: string = "",
        public fechaLecturaActual: string | null = null,
        public fechaLecturaAnterior: string | null = null,
        public mesesDeuda: string = "",
        public cuf: string = "",
        public nroFactura: string = "",
        public fecha: string = "",
        public detalle: any = [],
        public planilla_rucnit: string = "",
        public fecha_hora_pago: string = ""
    ) {
    }
}